export const DEFAULT_ABOUT_PROFILES = [
  {
    slug: 'anshuman-singh',
    name: 'Anshuman Singh',
    role: 'Creator',
    age: null,
    gender: '',
    bio: 'Building thoughtful products and systems that make ambitious ideas easier to ship.',
    detail: 'Anshuman helps shape the ideas, systems, and details that make Hunar easy to browse and use.',
    image_url: 'https://host.nextgenaischool.in/avatars/anshuman-singh.png',
    profile_url: 'https://anshuman791322.github.io',
    sort_order: 1,
    enabled: true,
  },
  {
    slug: 'lakshay-chawla',
    name: 'Lakshay Chawla',
    role: 'Creator',
    age: null,
    gender: '',
    bio: 'Designing useful AI workflows that turn rough ideas into products people can use.',
    detail: 'Lakshay works on the shop experience and the practical workflows behind Hunar.',
    image_url: 'https://host.nextgenaischool.in/avatars/lakshay-chawla.png',
    profile_url: 'https://lakshay-13.github.io',
    sort_order: 2,
    enabled: true,
  },
  {
    slug: 'hella',
    name: 'Hella',
    role: 'Maker',
    age: 21,
    gender: 'Female',
    bio: 'Hella brings a patient eye to gift-ready pieces and the small details that make a handmade order feel personal.',
    detail: 'She enjoys working with color, careful finishing touches, and ideas that become warm keepsakes.',
    image_url: '',
    profile_url: '',
    sort_order: 3,
    enabled: true,
  },
  {
    slug: 'peti',
    name: 'Peti',
    role: 'Maker',
    age: 20,
    gender: 'Female',
    bio: 'Peti works with careful hands and a playful sense of detail, especially on small pieces made to brighten everyday spaces.',
    detail: 'She brings a calm, curious energy to the studio and likes making useful objects that still feel personal.',
    image_url: '',
    profile_url: '',
    sort_order: 4,
    enabled: true,
  },
];

export const ABOUT_PROFILE_SLUGS = DEFAULT_ABOUT_PROFILES.map(({ slug }) => slug);

export function getProfileInitials(name = '') {
  return String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
}
